import {
  OnInit
} from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component
} from '@angular/core';
import { NotificationBellComponent } from '../../../../shared/components/notifications/notification-bell/notification-bell.component';

@Component({
    selector: 'vex-toolbar-notifications',
    templateUrl: './toolbar-notifications.component.html',
    styleUrls: ['./toolbar-notifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NotificationBellComponent]
})
export class ToolbarNotificationsComponent implements OnInit {

  constructor() {}

  ngOnInit() {}
}
